<template>
  <div v-if="userTiendasCodes && day" class="content-box">
    <div class="element-wrapper">
      <div class="row">

        <!-- CALENDAR COMPONENT INICIO -->
        <div class="col-sm-12 col-md-6 ">
          <div class="container_calendar white_gradient_bg_calendar shadow_inset_lg" :class="{ 'disabled-calendar': loading_eventos }">
            <div class="calendar border-0 m-3">
              <div class="header_calendar">
                <h6>{{ currentMonth }}</h6> 
                <div class="btn-group btn-group-toggle" data-toggle="buttons">
                  <button class="btn btn-sm btn-outline-link" @click="prevMonth">
                    <i class="fas fa-chevron-left"></i>
                  </button>
                  <button class="btn btn-sm btn-link" @click="today" style="color: #6b819b;">Hoy</button>
                  <button class="btn btn-sm btn-outline-link" @click="nextMonth">
                    <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
              </div>
              <div class="weekdays">
                <div v-for="day in weekdays" :key="day" class="weekday">{{ day }}</div>
              </div>
              <div class="days">
                <div v-for="(dayItem, index) in daysInMonth" :key="index" class="day"
                  :class="{ is_today: today_day == dayItem, is_selected: day == dayItem }" @click="onDateClick(dayItem)">
                  &nbsp; {{ dayItem }}
                </div>
              </div>
            </div>
          </div>
        <!-- CALENDAR COMPONENT FINAL -->

        <!-- FILTROS DE DATOS INICIO -->
        <div class="mt-3 mb-3">
          <div class="container_calendar white_gradient_bg_calendar shadow_inset_lg" :class="{ 'disabled-calendar': loading_eventos }">
            <div class="calendar border-0 m-3">
              <div class="header_calendar">
                <h6>Filtros de Datos</h6> 
              </div>

              <!-- filtro numero -->
              <div class="row justify-content-center text-center">
                <div class="col-sm-12 flex-wrap justify-content-center mt-3">
                  <div class="custom-input shadow_inset_lg" :class="{ 'disabled-filter': eventos_actuales.length == 0 }">
                    <input 
                      type="text"
                      class="form-control border-anullator text-center p-1"
                      v-model="numeroFilter"
                      @input="numeroFilter = $event.target.value.replace(/[^\d]/g, '')"
                      :disabled="eventos_actuales.length == 0"
                      placeholder="- Numero -"
                      style="background: transparent; border: none; width: 100%; color: #546171;"
                    >
                  </div>
                </div>
              </div>

              <!-- filtro tienda -->
              <div class="row justify-content-center text-center">
                <div class="col-sm-12 flex-wrap justify-content-center mt-3">
                  <div class="custom-input shadow_inset_lg" :class="{ 'disabled-filter': eventos_actuales.length == 0 }">
                    <v-select 
                      :key="'tienda-' + filterKey"
                      class="border-anullator" 
                      v-model="selected_tienda"
                      :options="tiendasOptions"
                      :reduce="t => t.codigo"
                      label="nombre"
                      :searchable="false"
                      :disabled="eventos_actuales.length == 0"
                      placeholder="- Tiendas -"
                    >
                      <template slot="no-options">- Tiendas -</template>
                    </v-select>
                  </div>
                </div>
              </div>

              <!-- filtro proveedor -->
              <div class="row justify-content-center text-center">
                <div class="col-sm-12 flex-wrap justify-content-center mt-3">
                  <ProveedoresSelectComponent 
                    :key="'proveedor-' + filterKey"
                    :current="providerFilter" 
                    :hideLabel="true" 
                    :disabled="eventos_actuales.length == 0"
                    :customClass="'custom-input shadow_inset_lg' + (eventos_actuales.length == 0 ? ' disabled-filter' : '')"
                    vSelectClass="border-anullator"
                  />
                </div>
              </div>
              
            </div>
          </div>
        </div>
        <!-- FILTROS DE DATOS FINAL -->
      </div>

        <!-- PANEL DE EVENTOS AGENDADOS INICIO-->
        <div class="element-box col-sm-12 col-md-6 white_gradient_bg_calendar shadow_inset_lg fixed-height-panel">
          <h6 v-if="today_day == day" class="form-header text" style="color: #6b819b;">
            Eventos para Hoy
          </h6>
          <h6 v-if="day != today_day" class="form-header text" style="color: #6b819b;">
            Eventos del {{ current.current_day }} de {{ currentMonth }}
          </h6>
          <div class="invoice-table text-center" style="margin-bottom: 0px; overflow: hidden; overflow-y: scroll; max-height: 65vh; position: relative; min-height: 200px;">
            <div v-if="loading_eventos" class="text-center py-5">
              <LoaderComponent :condicion="!loading_eventos" :sinTexto="true" />
            </div>
            <table v-else-if="eventos_filtrados.length > 0" class="table-hover text-center">
              <tbody class="text-center" v-for="det in eventos_filtrados" :key="det.id">
                <tr
                  class="event-row"
                  v-bind:style="det == detalle
                  ? 'background-color: #cdcdcd;'
                  : 'background-color: #00000000;'
                  " @click="OpenSlideOpt(det)">
                  <td style="width: 1500px; padding: 10px; border-radius: 10px" class="text-left">
                    <div class="row">
                      <div class="col-6 text-left" style="margin-bottom: -10px!important;">
                        <p class="font-weight-bold text-success">
                          {{ userTiendas.find(t => t.tienda.codigo == det.tienda).tienda.nombre || "Tienda No Encontrada" }}
                        </p>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-6 text-left">
                        <p class="font-weight-bold">
                          {{ tipoEvento[det.tipo] || det.tipo }}
                        </p>
                      </div>
                      <div class="col-6 text-right">
                        <p class="font-weight-bold text-dark">
                          # {{ det.numero.toLocaleString("en-GB") }}
                        </p>
                      </div>
                    </div>
                    <span>
                      {{ det.proveedor_obj.codigo }} -
                      {{ det.proveedor_obj.nombre }}
                    </span>
                    <br>
                    <span>{{ det.fecha_de | moment("hh:mm a") }} - {{ det.fecha_a | moment("hh:mm a") }}</span>
                    <br>
                    <span v-if="det.estado == 'A' && det.apl_agenda_orden_compra.length > 0" class="badge badge-info" style="float: right;">
                      <i class="fas fa-hourglass-start"></i>&nbsp;
                      Listo P/Recepción
                    </span>
                    <span v-if="det.estado == 'A' && det.apl_agenda_orden_compra.length == 0" class="badge badge-secondary" style="float: right;">
                      <i class="fas fa-hourglass-start"></i>&nbsp;
                      En espera
                    </span>
                    <span v-if="det.estado == '9'" class="badge badge-danger" style="float: right;">
                      <i class="fas fa-times"></i>&nbsp;
                      Evento cancelado
                    </span>
                    <span v-if="det.estado == 'E'" class="badge badge-blue" style="float: right;">
                      <i class="fas fa-history"></i>&nbsp;
                      En proceso
                    </span>
                    <span v-if="det.estado == 'C'" class="badge badge-success" style="float: right;">
                      <i class="fas fa-check"></i>&nbsp;
                      Evento finalizado
                    </span>
                  </td>
                </tr>
                <tr style="animation: fade-in 1.5s 1;" v-if="detalle == det">
                  <td style="border-radius: 10px">
                    <div v-if="det.estado == '9'">
                      <br>
                        <span class="text font-weight-bold" style="color: #6b819b;">
                          Motivo de Cancelación
                        </span>
                        <div class="row">
                          <div class="col-12">
                            <div class="btn btn-outline-danger disabled mt-1" style="border-radius: 25px;">
                              <i class="fas fa-times"></i>&nbsp;
                              {{ det.motivo_cancelacion_obj ? det.motivo_cancelacion_obj : "Desconocido" }}
                            </div>
                          </div>
                        </div>
                      <br>
                    </div>
                    <br />
                    <div class="row text-center mt-3">
                      <div class="col-12">
                        {{ detalle.observaciones }}
                      </div>
                      <div class="col-4">
                        <b class="text-dark" style="color: #6b819b!important;">
                          OC Asignadas:
                        </b>
                        <br />
                        {{ det.apl_agenda_orden_compra.length > 0 ? det.apl_agenda_orden_compra.length : "0" }}
                      </div>
                      <div class="col-4">
                        <b class="text-dark" style="color: #6b819b!important;">Tiempo Estimado</b>
                        <br />
                        {{ detalle.estimacion_recepcion }}
                      </div>
                      <div class="col-4">
                        <b class="text-dark" style="color: #6b819b!important;">Usuario</b>
                        <br />
                        {{ detalle.usuario_obj.first_name }}
                        {{ detalle.usuario_obj.last_name }}
                      </div>
                    </div>
                    <div class="row mt-4 justify-content-center">
                      <div class="col-12 mt-3" v-if="det.estado == 'E'" >
                        <button type="button" @click="linkRecepcion(det)"class="btn btn-dark py-3">
                          Ver Recepción&nbsp; <i class="fas fa-external-link-alt"></i>&nbsp;
                        </button>
                      </div>
                      <div 
                        class="col-sm-12 col-md-4 mt-3"
                        v-if="
                          isEventToday(det.fecha_de) && 
                          det.estado == 'A' &&
                          det.apl_agenda_orden_compra.length > 0
                        "
                      >
                        <button 
                          
                          type="button" 
                          :disabled="creando_recepcion"
                          @click="crearRecepcion(det)" 
                          class="btn btn-dark py-3 btn-block"
                        >
                          Recepcionar&nbsp; <i class="fas fa-check"></i>
                        </button>
                      </div>
                      <div 
                        class="col-sm-12 col-md-4 mt-3"
                        v-if="det.estado == 'A'"
                      >
                        <button 
                           type="button" 
                           @click="añadirOC(det)" 
                           class="btn btn-info btn-block py-3"
                        >
                          Asignar OC&nbsp; <i class="far fa-file-alt"></i>
                        </button>
                      </div>
                      <div class="col-sm-12 col-md-4 mt-3">
                        <button 
                          type="button" 
                          @click="cancelarAgenda(det)" 
                          v-if="det.estado == 'A'" 
                          class="btn btn-danger btn-block py-3"
                        >
                          Cancelar&nbsp; <i class="fas fa-ban"></i>
                        </button> 
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-else class="text-center py-2">
              <span style="color: #6b819b;">No hay eventos agendados para este día.</span>
            </div>
          </div>
          <hr>
          <button @click="addNewEvents()" :disabled="loading_eventos" class="btn btn-md btn-dark btn-block py-3">
            Agregar Evento &nbsp; <i class="fas fa-plus"></i>
          </button>
        </div>
        <!-- PANEL DE EVENTOS AGENDADOS FINAL-->


      </div>
    </div>

    <!-- Modal Para Crear Nuevo Evento en Agenda -->
    <NuevoEventoAgendaModal
      :date_select_patter="current.date_select"
    />

    <!-- Modal Para Asignar Orden de Compra a Evento en Agenda -->
    <AsignarOrdenCompraAgendaModal
      :eventoSeleccionadoOrdenCompra="eventoSeleccionadoOrdenCompra"
      :eventos_actuales="eventos_actuales"
    />

    <!-- Modal Cancelar Evento Pasado en Agenda -->
    <CancelarEventoAgendaModal
        :eventoSeleccionadoEliminar="eventoSeleccionadoEliminar"
        :tipoCancelacion="tipoCancelacion"
        :tipoEvento="tipoEvento"
      />

    <!-- Modal Recepcionar Evento en Agenda -->
    <CrearRecepcionAgendaModal
        :eventoSeleccionadoRecepcion="eventoSeleccionadoRecepcion"
      />

    <div v-if="!current.tienda.codigo" class="element-wrapper"></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Notifications from "@/notifications/notifications";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import AgendaProveedoresService from "@/services/wms/AgendaProveedoresService";
import DynamicService from "@/services/commons/DynamicService";
import CancelarEventoAgendaModal from "@/components/wms/agenda/CancelarEventoAgendaModal";
import CrearRecepcionAgendaModal from "@/components/wms/agenda/CrearRecepcionAgendaModal";
import NuevoEventoAgendaModal from "@/components/wms/agenda/NuevoEventoAgendaModal.vue";
import AsignarOrdenCompraAgendaModal from "./AsignarOrdenCompraAgendaModal.vue";
import LoaderComponent from "@/components/commons/LoaderComponent.vue";

export default {
  provide() {
    return {
      refreshAgenda: this.refreshEventosDATA,
    };
  },
  components: {
    ProveedoresSelectComponent,
    NuevoEventoAgendaModal,
    AsignarOrdenCompraAgendaModal,
    CancelarEventoAgendaModal,
    CrearRecepcionAgendaModal,
    LoaderComponent
  },
  data() {
    return {
      day: 1,
      detalle: "",
      creando_recepcion: false,
      current: { tienda: {} },
      calendarOptions: {
        selectable: {
          dateSelecting: true,
          eventDragging: true,
        },
        headerToolbar: {
          left: "",
          center: "title",
          right: "",
        },
        footerToolbar: {
          left: "dayGridMonth,timeGridWeek,timeGridDay",
          center: "today",
          right: "prev,next",
        },
        selectable: true,
        events: [],
        /* you can update a remote database when these fire:
        eventAdd:
        eventChange:
        eventRemove:
        */
      },
      eventoSeleccionadoEliminar: null,
      eventoSeleccionadoRecepcion: null,
      eventoSeleccionadoOrdenCompra: null,
      tipoCancelacion: [],
      tipoEvento: {
        R: "RECEPCIÓN",
        C: "CITA"
      },
      eventos_actuales: [],
      eventos_actuales_children: [],
      current_event: {
        proveedor: {
          errors: {},
        },
        proveedor_obj: {},
        errors: {},
        
      },
      userTiendas: [],
      userTiendasCodes: [],
      /**
       * CALENDAR COMPONENT DATA()
       */
      eventoSeleccionadoEliminarCC: null,
      today_day: "",
      day_select: 1,
      currentDate: new Date(),
      weekdays: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
      selected_tienda: null,
      providerFilter: { proveedor: null },
      filterKey: 0,
      loading_eventos: false,
      numeroFilter: "",
    };
  },
  computed: {
    monthInSpanish() {
      const monthsInSpanish = {
        "January": "Enero",
        "February": "Febrero",
        "March": "Marzo",
        "April": "Abril",
        "May": "Mayo",
        "June": "Junio",
        "July": "Julio",
        "August": "Agosto",
        "September": "Septiembre",
        "October": "Octubre",
        "November": "Noviembre",
        "December": "Diciembre"
      };
      return monthsInSpanish[this.currentMonth] || this.currentMonth;
    },
    currentMonth() {
      const monthsInSpanish = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
      ];
      const monthIndex = this.currentDate.getMonth();
      const year = this.currentDate.getFullYear();
      return `${monthsInSpanish[monthIndex]} ${year}`;
    },
    tiendasOptions() {
      return this.userTiendas.map(t => t.tienda);
    },
    daysInMonth() {
      const year = this.currentDate.getFullYear();
      const month = this.currentDate.getMonth();
      const firstDayOfMonth = new Date(year, month, 1).getDay(); // Día de la semana del primer día del mes (0: domingo, 1: lunes, ...)
      const daysInMonth = new Date(year, month + 1, 0).getDate(); // Número de días en el mes
      const days = Array.from({ length: firstDayOfMonth }, () => ""); // Rellenar con días en blanco hasta el primer día del mes
      for (let day = 1; day <= daysInMonth; day++) {
        days.push(day);
      }
      return days;
    },
    eventos_filtrados() {
      let filtered = this.eventos_actuales;
      
      if (this.selected_tienda) {
        filtered = filtered.filter(det => det.tienda == this.selected_tienda);
      }
      
      if (this.providerFilter.proveedor) {
        filtered = filtered.filter(det => det.proveedor == this.providerFilter.proveedor.codigo);
      }

      if (this.numeroFilter) {
        filtered = filtered.filter(det => det.numero.toString().includes(this.numeroFilter));
      }
      
      return filtered;
    }
  },
  watch: {
  },
  async mounted() {
    this.obtenerListadoMotivosCancelacion();
    await this.getUserTiendas();
    this.getFechaActual(); // Initialize current date for comparisons
    this.today();
  },
  methods: {
    ...mapActions({
      clearInvoiceState: "recepciones/clearInvoiceState",
    }),
    /**
     * Método que obtiene un arreglo de listas
     * de las tiendas asignadas al usuario
     */
    async getUserTiendas() {
      const tiendasArray = JSON.parse(localStorage.getItem("tiendas_usuario"));
      this.userTiendas = tiendasArray;
      this.userTiendasCodes = [];
      tiendasArray.forEach(tienda => {
          this.userTiendasCodes.push(tienda.tienda.codigo);
      });
    },

    /**
     * Método que obtiene el listado de los motivos de cancelacion
     * de un evento.
     */
     obtenerListadoMotivosCancelacion() {
      let self = this;
      DynamicService.getActionList(
        "wms",
        "agenda-proveedores",
        "lista_motivos_cancelacion"
      ).then((response) => {
        self.tipoCancelacion = response.data;
      })
      .catch((error) => {
        console.error(error);
      });
    },

    /**
     * Método que setea la data del evento, cuando se abre el panel 
     * inferior en donde se muestran los botónes o informacion detallada 
     * de los eventos en la agenda
     */
    OpenSlideOpt(det) {
      let self = this;
      if (self.detalle == det) {
        self.detalle = "";
        return;
      }
      self.detalle = det;
    },

    /**
     * Método que redirige al usuario a la Recepción abierta
     * del evento en proceso de recepción.
     */
    linkRecepcion(det) {
      let self = this;

      const navigate = () => {
        DynamicService.fetch("wms", "recepcion", {
          agenda_proveedor: det.id,
        }).then((response) => {
          let id = response.data.results[0].id;
          self.$router.push({
            name: "wms-recepcion-editar",
            params: {
              id: id,
            },
          });
        });
      };

      try {
        const p = this.clearInvoiceState ? this.clearInvoiceState() : Promise.resolve();
          p.then(navigate).catch(navigate);
      } catch (error) {
          navigate();
      };
    }, 
    /**
     * Método que abre el modal de Cancelar Evento.
     */
    cancelarAgenda(det) {
      let self = this;
      self.eventoSeleccionadoEliminar = det;
      $("#modalDeleteEvento").modal("show");
    },

    /**
     * Método que abre el modal de Asigar Orden De Compra.
     */
    añadirOC(det) {
      let self = this;
      self.eventoSeleccionadoOrdenCompra = det;
      $("#modalAddOC").modal("show");
    },

    /**
     * Método que abre el modal de Agregar Evento Nuevo.
     */
    addNewEvents() {
      $("#addCalendarEvents").modal("show");
    },

    /**
     * Método que nos sirve para crear una nueva recepcion
     * de evento de Proveedor Agendado
     */
    crearRecepcion(det) {
      let self = this;
      if (self.creando_recepcion) {
        return;
      }
      self.eventoSeleccionadoRecepcion = det;
      Notifications.alert.confirm(
        "Crear recepción",
        "¿Desea realizar esta acción?",
        "",
        function () {
          self.creando_recepcion = true;
          DynamicService.postAction(
            "wms",
            "agenda-proveedores",
            det.id,
            "crear_recepcion_desde_agenda"
          )
            .then((response) => {
              self.refreshEventosDATA();
              Notifications.alert.confirm(
                "¡Recepción creada exitosamente!",
                "¿Desea ir a la nueva recepción?",
                "",
                function () {
                  self.$router.push({
                    name: "wms-recepcion-editar",
                    params: {
                      id: response.data,
                    },
                  });
                }
              );
            })
            .catch((error) => {
              let detalle = "No se pudo crear la recepción. Intente de nuevo.";
              if (error.response && error.response.data && error.response.data.detail) {
                detalle = error.response.data.detail;
              }
              Notifications.alert.error("No se puede recepcionar", detalle);
              self.refreshEventosDATA();
            });
        }
      );
    },

    /**
     * Método que nos sirve para refrescar la data de la agenda de eventos
     * al momento de hacer el cambio de día en el componente calendario
     */
    refreshEventosDATA() {
      let self = this;
      this.creando_recepcion = false;
      this.eventos_actuales = [];
      this.loading_eventos = true;
      let params = {
        fecha_de__gte: this.current.fecha_de__gte,
        fecha_creacion: this.current.fecha_a__lte,
        fecha_a__lte: this.current.fecha_a__lte,
        tiendas: JSON.stringify(this.userTiendasCodes),
        quitar_paginacion: "true",
      }
      AgendaProveedoresService.fetch(params)
        .then((response) => {
          console.log(response.data);
          self.eventos_actuales = response.data;
          self.loading_eventos = false;
          if(self.eventoSeleccionadoOrdenCompra!= null) {
            self.eventoSeleccionadoOrdenCompra = self.eventos_actuales.find(
              (evento) => evento.id == self.eventoSeleccionadoOrdenCompra.id
            );
          }
        })  
        .catch((error) => {
          self.loading_eventos = false;
          Notifications.alert.error("No se ha podido realizar la acción", error.response);
        });
    },

  /**
   *  Métodos Necesarios para que el componente del calendario dinámico funcione
   */
   dataEventoSeleccionadoEliminarEmitCC(value) {
      this.eventoSeleccionadoEliminarCC = value;
    },
    today() {
      if (this.loading_eventos) return;
      this.currentDate = new Date();
      this.today_day = this.currentDate.getDate();
      this.day = this.currentDate.getDate();
      this.procesarFecha();
    },
    prevMonth() {
      if (this.loading_eventos) return;
      const prevMonthDate = new Date(this.currentDate);
      prevMonthDate.setMonth(prevMonthDate.getMonth() - 1);
      this.currentDate = prevMonthDate;
      this.procesarFecha();
    },
    nextMonth() {
      if (this.loading_eventos) return;
      const nextMonthDate = new Date(this.currentDate);
      nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);
      this.currentDate = nextMonthDate;
      this.procesarFecha();
    },
    isDayActive(day) {
      // Lógica para verificar si el día está agendado
      return false;
    },
    isTodayActive(day) {
      // Lógica para verificar el dia de
      return false;
    },
    isEventToday(date) {
      return moment(date).isSame(moment(), 'day');
    },

    
    getFechaActual() {
      this.current.fecha_actual = moment()
        .set({ hour: 0, minute: 0, second: 0 })
        .format("YYYY-MM-DD HH:mm:ss");
    },

    
    onDateClick(day) {
      if (this.loading_eventos) return;
      if (day !== null && day !== undefined && !isNaN(day)) {
        this.day = day;
        this.procesarFecha()
      } else {
        console.error('El día seleccionado no es válido');
      }
    },

    /**
     * Método que nos Ayuda a procesar la fecha seleccionada desde el
     * componente calendario
     */
    procesarFecha() {
      this.current.current_day = this.day;
      const spanishMonths = [
        "enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto",
        "septiembre", "octubre", "noviembre", "diciembre"
      ];
      const englishMonths = {
        "January": "enero", "February": "febrero", "March": "marzo", "April": "abril",
        "May": "mayo", "June": "junio", "July": "julio", "August": "agosto",
        "September": "septiembre", "October": "octubre", "November": "noviembre",
        "December": "diciembre"
      };
      let monthIndex = -1;
      const dateParts = this.currentMonth.match(/(\w+) (\d{4})/);
      if (dateParts) {
        const monthName = dateParts[1].toLowerCase();
        const year = dateParts[2];
        if (englishMonths[monthName.charAt(0).toUpperCase() + monthName.slice(1)]) {
          monthIndex = spanishMonths.indexOf(englishMonths[monthName.charAt(0).toUpperCase() + monthName.slice(1)]);
        } else {
          monthIndex = spanishMonths.indexOf(monthName);
        }
        if (monthIndex === -1) {
          console.error("El mes no es válido:", dateParts[1]);
          return;
        }
        this.current.date_select = new Date(year, monthIndex, this.current.current_day);
        if (isNaN(this.current.date_select)) {
          console.error("La fecha no es válida:", this.current.date_select);
          return;
        }
        this.current.date_select = moment(this.current.date_select).format("YYYY-MM-DD");
        this.current.fecha_de__gte = moment(this.current.date_select).set({ hour: 0, minute: 0, second: 0 }).format("YYYY-MM-DD HH:mm:ss");
        this.current.fecha_a__lte = moment(this.current.date_select).set({ hour: 23, minute: 59, second: 59 }).format("YYYY-MM-DD HH:mm:ss");
      } else {
        console.error("El formato de 'currentMonth' es incorrecto:", this.currentMonth);
      }
      
      console.log(this.selected_tienda);

      this.selected_tienda = null;
      this.providerFilter.proveedor = null;
      this.numeroFilter = "";
      this.filterKey++;
      
      this.refreshEventosDATA();
    },
  },
};
</script>
<style scoped>
.white_gradient_bg_calendar {
  background: #fafafa;
  background: radial-gradient(circle,rgba(255, 255, 255, 1) 0%, rgba(235, 235, 235, 1) 100%);
  border-radius: 15px;
}
.custom-input {
  border: 1px solid #bcbcbc;
  border-radius: 25px !important;
  padding: 12px 15px !important;
  height: auto !important;
  text-align: center;
  background-color: transparent !important;
  color: #45505e !important;
}
.custom-input input::placeholder {
  color: #4d5968 !important;
  font-size: 13px !important;
  opacity: 1; /* Firefox */
}

.custom-input >>> .vs__dropdown-toggle {
  border: none !important;
}
.custom-input >>> .vs__search {
  text-align: center !important;
  color: #546171 !important;
  font-size: 13px;
}
.custom-input >>> .vs__selected {
  text-align: center !important;
}

.disabled-filter {
  background-color: transparent !important;
  opacity: 0.5;
}

.disabled-filter >>> .vs__dropdown-toggle,
.disabled-filter >>> .vs__search,
.disabled-filter >>> .vs__selected {
  background-color: transparent !important;
}

.disabled-calendar {
  pointer-events: none;
  opacity: 0.6;
  transition: opacity 0.3s ease;
}

.badge {
  font-size: 11px;
  padding: 3.5px 11px;
  border-radius: 12px;
  text-transform: capitalize;
  height: 20px;
  width: 130px;
}
.container_calendar {
  background-color: white;
  display: flex;
  justify-content: center;
  padding: 0px;
}

/* Estilos del calendario */
.calendar {
  width: 100%;
  border: 1px solid #c9c9c9;
  border-radius: 15px;
  padding: 10px;
}

.header_calendar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 5px;
  margin-bottom: 5px;
}

.weekday {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  background-color: #9a9a9a00;
  border-radius: 5px;
  font-weight: bold;
  color: #6a6a6a;
  transition: all 0.5s ease;
}

.weekday:hover {
  box-shadow: 0 0 8px inset #4949496f;
  transition: all 0.5s ease;
}

.days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}

.day {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding-bottom: 50%;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 5%;
  /* Relación de aspecto 1:1 (cuadrado) */
  font-size: 16px;
  cursor: pointer;
  font-weight: bold;
  color: #2a7cda;
  border-radius: 5px;
  transition: all 0.5s ease;
}

.day:hover {
  background-color: #f3f3f396;
  box-shadow: 0 0 15px inset #49494955;
  transition: all 0.5s ease;
}

.is_today {
  color: rgb(235, 106, 106);
  box-shadow: 0 0 15px inset #49494955;
  font-weight: bold;
  background-color: #8ac8fb46;
}

.is_selected {
  background-color: #5d89bb !important;
  box-shadow: 0 0 15px inset #49494955;
  color: white !important;
}

.agendado {
  background-color: red;
  /* Cambiar el color aquí para indicar un día agendado */
  color: white;
}

.fixed-height-panel {
  height: 80dvh;
  margin-top: 0px !important;
  display: flex;
  flex-direction: column;
}

.fixed-height-panel .invoice-table {
  flex-grow: 1;
}
.event-row {
  cursor: pointer;
  transition: all 0.4s ease;
}
.event-row:hover {
  background-color: #dcdcdc !important;
}
</style>
